import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface ActionButtonProps {
  text?: string;
  variant?: 'solid' | 'outlined';
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  children?: React.ReactNode;
}
const ActionButton: React.FC<ActionButtonProps> = t0 => {
  const $ = _c(4);
  const {
    text,
    variant: t1,
    onClick,
    className,
    children
  } = t0;
  const variant = t1 === undefined ? "solid" : t1;
  const t2 = `w-full py-3 rounded-full text-2xl font-medium md:font-medium font-lora transition-all duration-300 ${variant === "solid" ? "bg-[#037A6A] text-white " : "border border-[#037A6A] text-[#037A6A]  "} ${className}`;
  const t3 = children || text;
  let t4;
  if ($[0] !== onClick || $[1] !== t2 || $[2] !== t3) {
    t4 = <button onClick={onClick} className={t2}>{t3}</button>;
    $[0] = onClick;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export default ActionButton;